export enum PaymentMode {
  PAY_IN_FULL = 'PAY_IN_FULL',
  SPLIT_PAYMENT = 'SPLIT_PAYMENT',
}

export enum PaymentSubScreen {
  MAIN_SCREEN = 'MAIN_SCREEN',
  PAYMENT_SUCCEEDED = 'PAYMENT_SUCCEEDED',
  PAYOUT_SCREEN = 'PAYOUT_SCREEN',
  GIFT_CARD_CONFIRM_PAYMENT_SCREEN = 'GIFT_CARD_CONFIRM_PAYMENT_SCREEN',
}

export enum PaymentAction {
  SET_PAYMENT_AMOUNT = 'SET_PAYMENT_AMOUNT',
  UPDATE_PAYMENT_AMOUNT = 'UPDATE_PAYMENT_AMOUNT',
  UPDATE_PAYMENT_MODE = 'UPDATE_PAYMENT_MODE',
  UPDATE_PAYMENT_INFO_FROM_ORDER = 'UPDATE_PAYMENT_INFO_FROM_ORDER',
  TAKE_NEXT_PAYMENT = 'TAKE_NEXT_PAYMENT',
  CANCEL_CURRENT_STEP = 'CANCEL_CURRENT_STEP',
  CANCEL_PAY_BY_SEAT = 'CANCEL_PAY_BY_SEAT',
  PAY_OUT = 'PAY_OUT',
  RESET_INITIAL_STATE = 'RESET_INITIAL_STATE',
  UPDATE_CUSTOMER_BALANCE_PAYMENT = 'UPDATE_CUSTOMER_BALANCE_PAYMENT',
  SETUP_NUMBER_OF_SPLIT_PAYMENT = 'SETUP_NUMBER_OF_SPLIT_PAYMENT',
  SPLIT_BY_SEAT = 'SPLIT_BY_SEAT',
  SELECT_SEAT_NUMBER = 'SELECT_SEAT_NUMBER',
  SPLIT_BY_PRODUCT = 'SPLIT_BY_PRODUCT',
  UPDATE_SELECTED_ORDER_ITEMS = 'UPDATE_SELECTED_ORDER_ITEMS',
  SET_GIFT_CARD_PAYMENT_SCREEN = 'SET_GIFT_CARD_PAYMENT_SCREEN',
}

export enum TerminalStatus {
  OK = 'OK',
  BUSY = 'BUSY',
  MAINTENANCE = 'MAINTENANCE',
  UNREACHABLE = 'UNREACHABLE',
}

export enum TerminalPrinterStatus {
  OK = 'OK',
  PAPER_LOW = 'PAPER_LOW',
  NO_PAPER = 'NO_PAPER',
  PAPER_JAM = 'PAPER_JAM',
  OUT_OF_ORDER = 'OUT_OF_ORDER',
}

export enum DefaultPaymentTypes {
  CARD = 'Card',
  ONLINE = 'Online',
  CASH = 'Cash',
  ON_ACCOUNT = 'On Account',
  SEVENROOMS = 'Sevenrooms',
  GIFT_CARD = 'Gift Card',
  MOTO = 'MOTO',
  MANUAL_EFTPOS = 'Manual EFTPOS',
}

export enum PaymentTypes {
  CARD = 'Card',
  ONLINE = 'Online',
  CASH = 'Cash',
  ON_ACCOUNT = 'On Account',
  SEVENROOMS = 'Sevenrooms',
  NOWBOOKIT = 'Now Book It',
  MOTO = 'MOTO',
}

export const PAYMENT_INPROGRESS_MESSAGES = [
  'Uncompleted transaction',
  'A tx query is still being evaluated.',
];

// Adyen returns this when a concurrent TransactionStatus query is already
// in-flight for the same ServiceID. The message is dynamic (contains the ID),
// so match by prefix rather than exact string.
export const PAYMENT_REPEATED_DB_MESSAGE_PREFIX = 'Repeated DB Message:';

export const POS_PAYMENT_CANCEL_MESSAGES = [
  '104 Merchant cancelled tx',
  '224 Merchant cancelled during authorize online',
  'Transaction aborted',
  'Transaction cancelled',
  'Transaction got refused',
];

export enum PaymentCardTypes {
  VISA = 'visa',
  VISA_DEBIT = 'visa_debit',
  VISA_CREDIT = 'visa_credit',
  MASTERCARD = 'mc',
  MASTERCARD_DEBIT = 'mc_debit',
  MASTERCARD_CREDIT = 'mc_credit',
  AMERICAN_EXPRESS = 'amex',
  EFTPOS_SAVING = 'eftpos_australia_sav',
  EFTPOS_CHQ = 'eftpos_australia_chq',
  OTHER = 'other',
}

export enum SplitPaymentBy {
  BY_PRODUCT = 'BY_PRODUCT',
  BY_AMOUNT = 'BY_AMOUNT',
  BY_SEAT = 'BY_SEAT',
}

export enum RefundType {
  FULL = 'FULL',
  BY_AMOUNT = 'BY_AMOUNT',
  By_PRODUCT = 'By_PRODUCT',
}
